import { render, staticRenderFns } from "./CheckboxGroupButton.vue?vue&type=template&id=668436f3"
import script from "./CheckboxGroupButton.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports